<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('coop_ads')"
                        :isNewButton="true"
                        @new-button-click="showCreateForm()"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('coop_ads')"
                              :isNewButton="true"
                              @new-button-click="showCreateForm()"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="true"
                              @exportExcel="$refs.datatable.excel()">
                <b-row>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('coop_company')">
                            <b-form-select v-model="datatable.queryParams.filter.company_id" :options="companyOptions" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="datatable.queryParams.filter.status" :options="statusFilterOptions" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('start_date')">
                            <b-form-input v-model="datatable.queryParams.filter.start_date" type="date"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="3">
                        <b-form-group :label="$t('end_date')">
                            <b-form-input v-model="datatable.queryParams.filter.end_date" type="date"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('department')">
                            <department-selectbox :faculty_code="datatable.queryParams.filter.faculty_code"
                                                   v-model="datatable.queryParams.filter.department_code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('class')">
                            <classes-selectbox v-model="datatable.queryParams.filter.class" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable ref="datatable"
                       :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
                       :data-function="callService"
            />

            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t(modalTitle) }}
                </template>
                <template v-slot:CommonModalContent>
                    <component v-if="modalComponent" :is="modalComponent" @actionSuccess="actionSuccess" :formId="formId"/>
                </template>
            </CommonModal>

            <CommonModal ref="statusModal" size="md" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('update') }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-form-group :label="$t('status')">
                        <b-form-select v-model="selectedStatus" :options="statusOptions" />
                    </b-form-group>
                    <b-button variant="primary" @click="updateStatus(selectedStatus)">{{ $t('save') }}</b-button>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
    import DepartmentSelectbox from '@/components/interactive-fields/DepartmentSelectbox';
    import ClassesSelectbox from '@/components/interactive-fields/ClassesSelectbox';

    //Page
    import CreateForm from './CreateForm';
    import UpdateForm from './UpdateForm';

    //Service
    import CoopAdService from '@/services/CoopAdService';
    import CoopCompanyService from '@/services/CoopCompanyService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            FacultySelectbox,
            DepartmentSelectbox,
            ClassesSelectbox,

            CreateForm,
            UpdateForm
        },
        metaInfo() {
            return {
                title: this.$t('coop_ads')
            }
        },
        data() {
            return {
                formId: null,
                modalTitle: null,
                modalComponent: null,
                statusFormId: null,
                selectedStatus: null,
                statusOptions: [
                    {value: 'active', text: this.$t('active')},
                    {value: 'passive', text: this.$t('passive')}
                ],
                companyOptions: [],
                statusFilterOptions: [
                    {value: null, text: ''},
                    {value: 'active', text: this.$t('active')},
                    {value: 'passive', text: this.$t('passive')}
                ],
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('coop_update_status'),
                                    class: 'ri-refresh-line',
                                    callback: (row) => {
                                        this.showStatusModal(row.id);
                                    }
                                },
                                {
                                    text: this.$t('coop_view_applications'),
                                    class: 'ri-file-list-3-line',
                                    callback: (row) => {
                                        this.$router.push('/coop/ads/' + row.id + '/applications');
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('coop_company'),
                            field: 'company_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_position'),
                            field: 'position',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('start_date'),
                            field: 'start_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('end_date'),
                            field: 'end_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_application_count'),
                            field: 'application_count',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            formatFn: (status) => {
                                return status === 'active' ? this.$t('active') : this.$t('passive');
                            },
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        created() {
            this.getRows();
            CoopCompanyService.getAll({params: {filter: {}, page: 1, limit: 1000}}).then((response) => {
                this.companyOptions = [{value: null, text: ''}].concat(response.data.data.map((company) => ({
                    value: company.id,
                    text: company.name
                })));
            });
        },
        methods: {
            callService(config) {
                return CoopAdService.getAll(config);
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CoopAdService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            showCreateForm() {
                this.formId = null;
                this.modalComponent = 'create-form';
                this.modalTitle = 'new';
                this.$refs.showModal.$refs.commonModal.show();
            },
            formClear() {
                this.formId = null;
                this.modalComponent = null;
                this.modalTitle = null;
            },
            actionSuccess() {
                this.$refs.showModal.$refs.commonModal.hide();
                this.getRows();
                this.formClear();
            },
            showStatusModal(id) {
                this.statusFormId = id;
                this.selectedStatus = null;
                this.$refs.statusModal.$refs.commonModal.show();
            },
            updateStatus(status) {
                CoopAdService.updateStatus(this.statusFormId, status).then((response) => {
                    this.$toast.success(this.$t(response.data.message));
                    this.$refs.statusModal.$refs.commonModal.hide();
                    this.getRows();
                });
            }
        }
    }
</script>
